var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"print-pdf"},[_c('button',{staticClass:"print-button",attrs:{"disabled":_vm.loading},on:{"click":_vm.handlePrint}},[_vm._v("\n    "+_vm._s(_vm.loading ? '正在准备...' : '打印PDF')+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dee87a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrintPDF.vue
// module id = null
// module chunks = 